module.exports = __webpack_public_path__ + "static/media/StillyHeaderImage-1.f8410c2e.JPG";